import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import IconsGen from "../../../icons_generator/IconsGen";
import { useTranslation } from "react-i18next";

import * as XLSX from "xlsx";
import { useNavigate, useParams } from "react-router-dom";
import AxiosController from "../../../authentication/AxiosController";
import ordersSheetColsFulfillment from "./ordersSheetColsFulfillment";
import { notification } from "antd";

const get_shippingcosts = (slug, lang, token, shippingcostsHandler) => {
  AxiosController.get(`api/${slug}/${lang}/get-shippingcost/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      shippingcostsHandler(res.data);
    })
    .catch((e) => {});
};
const validateBulkOrders = (slug, lang, token, sheetOrders, setSheetOrdersErr, navigate, setSheetOrders) => {

  
  AxiosController.post(
    `api/${slug}/${lang}/orders/place/multiple`,
    sheetOrders,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  )
    .then((res) => {
      
      setSheetOrdersErr({});
      setSheetOrders(sheetOrders);

    })
    .catch((e) => {
      const err = e.response?.data?.error;
      if (typeof err === "string") return;
      setSheetOrdersErr(err || {});
    });
};

const UploadExcelFulfillment = ({ handleLoader, setSheetOrdersErr, setSheetOrders }) => {
  const { slug, lang } = useParams();
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [_] = useTranslation("global");
  const fileInputRef = useRef(null);
  const [shippingcosts, shippingcostsHandler] = useState([]);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (placement, status, success = true) => {
    if (success) {
      api.success({
        style: { direction: lang == "ar" ? "rtl" : "ltr" },
        description: `${status}!`,
        placement,
      });
    } else {
      api.error({
        style: { direction: lang == "ar" ? "rtl" : "ltr" },
        description: `${status}!`,
        placement,
      });
    }
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    
    // Validate file type
    if (!file || (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls'))) {
      openNotification(
        lang == "ar" ? "topRight" : "topLeft",
        "Please upload an Excel file (.xlsx or .xls)",
        false
      );
      return;
    }
    
    handleLoader(true);
    const reader = new FileReader();
    const shippingcostsNames = shippingcosts.map((v) => v.arabic_name);
    
    // Check if shipping costs are loaded
    if (shippingcostsNames.length === 0) {
      openNotification(
        lang == "ar" ? "topRight" : "topLeft",
        "Shipping costs not loaded. Please try again.",
        false
      );
      handleLoader(false);
      return;
    }
    
    let localOrdersSheet = [];
    let phoneNumbers = {};
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      
      // Check if file has data
      if (!json || json.length < 2) {
        handleLoader(false);
        openNotification(
          lang == "ar" ? "topRight" : "topLeft",
          "Excel file is empty or has no data rows",
          false
        );
        return;
      }
      
      const columns = json[0];
      
      // Check if columns array exists and has enough columns
      if (!columns || columns.length < ordersSheetColsFulfillment.length) {
        handleLoader(false);
        openNotification(
          lang == "ar" ? "topRight" : "topLeft",
          "Excel file format is incorrect. Please use the correct template.",
          false
        );
        return;
      }
      
      // More flexible column validation - check if all required columns exist
      const isValid = ordersSheetColsFulfillment.every(
        (expectedCol, index) => {
          const actualCol = columns[index];
          return actualCol && actualCol.toString().trim() === expectedCol.toString().trim();
        }
      );
      
      if (isValid) {
        for (let index = 1; index < json.length; index++) {
          if (!json[index] || json[index].every((v) => {
            return v == '' || v == null || v == undefined;
          })) break;
          const element = json[index];
          
          // Check if element has enough columns
          if (!element || element.length < ordersSheetColsFulfillment.length) {
            openNotification(
              lang == "ar" ? "topRight" : "topLeft",
              `Row ${index + 1} has insufficient data. Please check the format.`,
              false
            );
            handleLoader(false);
            return;
          }
          
          // Validate required fields
          if (!element[0] || !element[1] || !element[4] || !element[7]) {
            openNotification(
              lang == "ar" ? "topRight" : "topLeft",
              `Missing required fields in row ${index + 1}`,
              false
            );
            handleLoader(false);
            return;
          }
          
          let nameIndex = shippingcostsNames.indexOf(element[5])
          if (nameIndex === -1) {
            openNotification(
              lang == "ar" ? "topRight" : "topLeft",
              `${_("panel.govError")} ${index + 1}`,
              false
            );
            handleLoader(false);
            return;
          }
          if (!phoneNumbers.hasOwnProperty(element[7])) {
            const orderObj = {
              reference_order: element[0],
              customer_name: element[4], 
              COD: element[2], 
              gov_id: shippingcosts[nameIndex].id,
              phone_1: element[7],
              phone_2: element[8],
              address: element[6],
              public_notes: element[9],
              private_notes: element[10],
              variants: [
                {
                  price: 0,
                  quantity: element[3],
                  sku: element[1],
                },
              ],
            };
            phoneNumbers[element[7]] = localOrdersSheet.length;
            localOrdersSheet = [...localOrdersSheet, orderObj];
          }else {
            localOrdersSheet[phoneNumbers[element[7]]].variants.push({
              price: 0,
              quantity: element[3],
              sku: element[1],
            });
          }

        }
        validateBulkOrders(slug, lang, token, localOrdersSheet, setSheetOrdersErr, navigate, setSheetOrders);
        handleLoader(false);
        localOrdersSheet = [];
      } else {
        // Fallback: Try to process even if column headers don't match exactly
        if (columns && columns.length >= ordersSheetColsFulfillment.length) {
          for (let index = 1; index < json.length; index++) {
            if (!json[index] || json[index].every((v) => {
              return v == '' || v == null || v == undefined;
            })) break;
            const element = json[index];
            
            // Check if element has enough columns
            if (!element || element.length < ordersSheetColsFulfillment.length) {
              openNotification(
                lang == "ar" ? "topRight" : "topLeft",
                `Row ${index + 1} has insufficient data. Please check the format.`,
                false
              );
              handleLoader(false);
              return;
            }
            
            // Validate required fields
            if (!element[0] || !element[1] || !element[4] || !element[7]) {
              openNotification(
                lang == "ar" ? "topRight" : "topLeft",
                `Missing required fields in row ${index + 1}`,
                false
              );
              handleLoader(false);
              return;
            }
            
            let nameIndex = shippingcostsNames.indexOf(element[5])
            if (nameIndex === -1) {
              openNotification(
                lang == "ar" ? "topRight" : "topLeft",
                `${_("panel.govError")} ${index + 1}`,
                false
              );
              handleLoader(false);
              return;
            }
            if (!phoneNumbers.hasOwnProperty(element[7])) {
              const orderObj = {
                reference_order: element[0],
                customer_name: element[4], 
                COD: element[2], 
                gov_id: shippingcosts[nameIndex].id,
                phone_1: element[7],
                phone_2: element[8],
                address: element[6],
                public_notes: element[9],
                private_notes: element[10],
                variants: [
                  {
                    price: 0,
                    quantity: element[3],
                    sku: element[1],
                  },
                ],
              };
              phoneNumbers[element[7]] = localOrdersSheet.length;
              localOrdersSheet = [...localOrdersSheet, orderObj];
            }else {
              localOrdersSheet[phoneNumbers[element[7]]].variants.push({
                price: 0,
                quantity: element[3],
                sku: element[1],
              });
            }
          }
          validateBulkOrders(slug, lang, token, localOrdersSheet, setSheetOrdersErr, navigate, setSheetOrders);
          handleLoader(false);
          localOrdersSheet = [];
        } else {
          handleLoader(false);
          openNotification(
            lang == "ar" ? "topRight" : "topLeft",
            "Excel file format is incorrect. Please use the correct template.",
            false
          );
        }
      }
    };

    reader.onerror = () => {
      handleLoader(false);
      openNotification(
        lang == "ar" ? "topRight" : "topLeft",
        "Error reading file. Please try again.",
        false
      );
    };
    
    reader.readAsArrayBuffer(file);
  };
  useEffect(() => {
    get_shippingcosts(slug, lang, token, shippingcostsHandler);
  }, []);
  return (
    <>
      {contextHolder}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileUpload}
      />
      <Button
        style={{
          backgroundColor: "rgb(243, 168, 55)",
          color: "white",
          border: "none",
          width: "100%",
        }}
        className="fs-5 d-flex justify-content-center align-items-center px-2 py-2 gap-2"
        onClick={handleButtonClick}
      >
        <IconsGen icon_name={"uploadExcelTaager"} />
        <p>{_("panel.uploadExcel")}</p>
      </Button>
    </>
  );
};

export default UploadExcelFulfillment;
